import { tryCatch } from '@wix/funnel-utils'
import { useCallback, useEffect, useRef, useState } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { fedopsLogger } from '../../../monitoring/fedops'
import { reportError } from '../../../monitoring/reportError'

type State = { type: 'loading' } | { type: 'error'; error: Error } | { type: 'ready'; email: string }

export const useLoadEmail = () => {
  const [state, setState] = useState<State>({ type: 'loading' })

  const isUnmount = useRef(false)
  const reload = useCallback(async () => {
    fedopsLogger.interactionStarted('load-current-email')
    setState({ type: 'loading' })
    const promise = ambassadorHttpClient.get('/_api/wix-html-login-webapp/user/getUserDetails')
    const [error, response] = await tryCatch(() => promise)
    // TODO: either this or on each branch error/success this condition
    if (isUnmount.current) {
      return
    }
    if (error) {
      reportError(error)
      return setState({ type: 'error', error })
    }
    const email = response.data.payload.email
    if (!email) {
      const error = new Error('no email in the getUserDetails response')
      reportError(error)
      return setState({ type: 'error', error })
    }
    fedopsLogger.interactionEnded('load-current-email')
    return setState({ type: 'ready', email })
  }, [])

  useEffect(() => {
    void reload()
    return () => {
      isUnmount.current = true
    }
  }, [reload])

  return [state, reload] as const
}
